import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { logger } from 'packages';
import MultiCurrencySelector from './multi-currency-selector';
import MultiCurrencyMobileMenuButton from './multi-currency-mobile-menu-button';
import initData from 'init-data';
import MultiCurrencyMobileSelector from './multi-currency-mobile-selector';

const renderElement = (element, reduxStore, component) => {
    try {
        ReactDOM.render(
            <Provider store={reduxStore}>{component}</Provider>,
            element
        );
    } catch (e) {
        logger(e);
    }
};

const prepareElementInMobileMenu = () => {
    const mobileMenuButton = document.querySelector(
        '[data-multi-currency-mobile-menu-button]'
    );
    mobileMenuButton.className += ' multi-currency-active';
    return mobileMenuButton;
};

const createMountPoint = () => {
    const newElement = document.createElement('div');
    document.body.insertBefore(newElement, document.body.firstChild);
    return newElement;
};

const render = reduxStore => {
    if (!initData.currencies || initData.currencies.length === 0) {
        return;
    }
    renderElement(createMountPoint(), reduxStore, <MultiCurrencySelector />);
    renderElement(
        createMountPoint(),
        reduxStore,
        <MultiCurrencyMobileSelector />
    );
    renderElement(
        prepareElementInMobileMenu(),
        reduxStore,
        <MultiCurrencyMobileMenuButton />
    );
};

export default {
    render
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/multi-currency/multi-currency-selector-renderer.jsx